import { create } from 'zustand';

/**
 * Toasts stack at the top of the screen, under the safe area (the bottom is the thumb zone and
 * the tab bar). Undo toasts last 6 s, the rest 4 s.
 *
 *   toast({ title: 'Bucket removed. The ref has spoken.', action: { label: 'Undo', onPress } })
 */
export type ToastTone = 'info' | 'success' | 'warning' | 'danger';

export interface ToastInput {
  title: string;
  body?: string;
  tone?: ToastTone;
  action?: { label: string; onPress: () => void };
  /** ms; default 4000, or 6000 when there is an action. 0 keeps it until dismissed. */
  duration?: number;
}

export interface Toast extends ToastInput {
  id: number;
  tone: ToastTone;
}

interface ToastState {
  items: Toast[];
  push(t: ToastInput): number;
  dismiss(id: number): void;
}

let nextId = 1;

export const useToasts = create<ToastState>((set, get) => ({
  items: [],
  push: (t) => {
    const id = nextId++;
    const item: Toast = { tone: 'info', ...t, id };
    set({ items: [...get().items.slice(-2), item] });
    const ms = t.duration ?? (t.action ? 6000 : 4000);
    if (ms > 0) setTimeout(() => get().dismiss(id), ms);
    return id;
  },
  dismiss: (id) => set({ items: get().items.filter((x) => x.id !== id) }),
}));

export function toast(t: ToastInput): number {
  return useToasts.getState().push(t);
}
